import { render, staticRenderFns } from "./residential_address.vue?vue&type=template&id=ee2972ce&"
import script from "./residential_address.vue?vue&type=script&lang=js&"
export * from "./residential_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports